import { FC } from "react";
import { MdsIcon } from "@/design-system/components/icon/MdsIcon";
import { MdsIconKind } from "@/design-system/components/icon/types";
import { MDSTextOverflow, MDSTextVariant, MDSTextColor } from "@/mds";
import { StyledChip, StyledIconContainer, StyledLabelText } from "@/components/chips/chip.style";

interface TemplateChipProps {
  title: string;
  inline?: boolean;
}

export const TemplateChip: FC<TemplateChipProps> = ({ title, inline }) => (
  <StyledChip $inline={inline}>
    <StyledIconContainer $inline={inline}>
      <MdsIcon kind={MdsIconKind.Template} />
    </StyledIconContainer>
    <StyledLabelText
      $inline={inline}
      variant={MDSTextVariant.HeaderL}
      color={MDSTextColor.Contrast}
      overflow={MDSTextOverflow.Ellipsis}
    >
      {title}
    </StyledLabelText>
  </StyledChip>
);
